/** Region codes shared by API, dropdown, and map (region_id in census output JSON) */
export type AccidentAtlasRegionId =
  | 'DE'
  | 'BW'
  | 'BY'
  | 'BE'
  | 'BB'
  | 'HB'
  | 'HH'
  | 'HE'
  | 'MV'
  | 'NI'
  | 'NW'
  | 'RP'
  | 'SL'
  | 'SN'
  | 'ST'
  | 'SH'
  | 'TH'

export type AccidentAtlasBundeslandId = Exclude<AccidentAtlasRegionId, 'DE'>

export const DEUTSCHLAND_REGION_ID = 'DE' as const

export const BUNDESLAND_REGION_IDS: AccidentAtlasBundeslandId[] = [
  'BW',
  'BY',
  'BE',
  'BB',
  'HB',
  'HH',
  'HE',
  'MV',
  'NI',
  'NW',
  'RP',
  'SL',
  'SN',
  'ST',
  'SH',
  'TH',
]

export const REGION_NAMES: Record<AccidentAtlasRegionId, string> = {
  DE: 'Deutschland',
  BW: 'Baden-Württemberg',
  BY: 'Bayern',
  BE: 'Berlin',
  BB: 'Brandenburg',
  HB: 'Bremen',
  HH: 'Hamburg',
  HE: 'Hessen',
  MV: 'Mecklenburg-Vorpommern',
  NI: 'Niedersachsen',
  NW: 'Nordrhein-Westfalen',
  RP: 'Rheinland-Pfalz',
  SL: 'Saarland',
  SN: 'Sachsen',
  ST: 'Sachsen-Anhalt',
  SH: 'Schleswig-Holstein',
  TH: 'Thüringen',
}

export function isAccidentAtlasRegionId(
  id: string
): id is AccidentAtlasRegionId {
  return id in REGION_NAMES
}

export function isBundeslandRegionId(
  id: string
): id is AccidentAtlasBundeslandId {
  return id !== DEUTSCHLAND_REGION_ID && isAccidentAtlasRegionId(id)
}

export function getRegionName(id: string): string | undefined {
  return isAccidentAtlasRegionId(id) ? REGION_NAMES[id] : undefined
}

/** Selected region for data lookup; undefined defaults to Germany (DE) */
export function resolveRegionId(
  selection?: AccidentAtlasRegionId
): AccidentAtlasRegionId {
  return selection ?? DEUTSCHLAND_REGION_ID
}
